import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import styles from '../../../ApplicationMaintenance.module.scss';
const ComponentSelect = ({
	options,
	handleChange,
	selected,
	validationErrors = [],
}) => {
	return (
		<>
			<FormControl sx={{ minWidth: 140 }}>
				<InputLabel id='componentSelectDropdown-label'>
					Component
				</InputLabel>
				<Select
					labelId='componentSelectDropdown-label'
					id='componentSelectDropdown'
					value={selected?.id ?? ''}
					onChange={handleChange}
					error={validationErrors.length > 0}
					label='component'
				>
					{options.map(option => {
						return (
							<MenuItem key={option.id} value={option.id}>
								{option.label}
							</MenuItem>
						);
					})}
				</Select>
				<div>
					<ul>
						{validationErrors.map(err => (
							<li className={styles.error}>{err.message}</li>
						))}
					</ul>
				</div>
			</FormControl>
		</>
	);
};

export default ComponentSelect;
